<template>
  <div class="mb-3">
    <custom-callout border-color="#b5c3bc" :has-toggle="false">
      <div class="row pt-2">
        <div class="col-12 col-md-2 custom-pl">
          <div class="d-flex flex-column">
            <span class="color-gray-6 d-block font-14">Proveedor</span>
            <span class="font-16 color-black font-weight-bold">
              {{ data.name | empty }}
            </span>
          </div>
        </div>

        <div class="col-12 col-md-2 custom-pl">
          <div class="d-flex flex-column">
            <span class="color-gray-6 d-block font-14">
              Representante del Proveedor
            </span>
            <span class="font-16 color-black font-weight-bold">
              {{ data.representant | empty }}
            </span>
          </div>
        </div>

        <div class="col-12 col-md-2 custom-pl">
          <div class="d-flex flex-column">
            <span class="color-gray-6 d-block font-14">Teléfono</span>
            <span class="font-16 color-black font-weight-bold">
              {{ data.phoneNumber | phone }}
            </span>
          </div>
        </div>

        <div class="col-12 col-md-2 custom-pl">
          <div class="d-flex flex-column">
            <span class="color-gray-6 d-block font-14">Correo Electrónico</span>
            <span class="font-16 color-black font-weight-bold text-truncate">
              {{ data.email | empty }}
            </span>
          </div>
        </div>

        <div class="col-12 col-md-2 custom-pl">
          <div class="d-flex flex-column">
            <span class="color-gray-6 d-block font-14">Dirección</span>
            <span class="font-16 color-black font-weight-bold">
              {{ data.address | empty }}
            </span>
          </div>
        </div>

        <div v-if="!isReadOnly" class="col-12 col-md-2 custom-pl">
          <div class="d-flex align-items-center justify-content-md-end h-100">
            <check-box
              class="row-check"
              :value="data.checked"
              @input="onToggle"
            />
          </div>
        </div>
      </div>
    </custom-callout>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import CheckBox from 'CheckBox';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';

export default {
  name: 'ProviderRow',
  components: { CustomCallout, CheckBox },
  mixins: [alertMixin],
  props: {
    data: {
      type: Object,
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    onToggle(checked) {
      this.$emit('toggle', { id: this.data.id, checked });
    },
  },
};
</script>

<style lang="scss" scoped></style>
